import createIcon from '../../createIcon';

/**
 * @component @name Scanner
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuOCAxMC4yTDQuMiA0LjVMMy41IDYuNEwxNy42IDExLjVINUMzLjkgMTEuNSAzIDEyLjQgMyAxMy41VjE3LjVDMyAxOC42IDMuOSAxOS41IDUgMTkuNUgxOUMyMC4xIDE5LjUgMjEgMTguNiAyMSAxNy41VjEyQzIxIDExLjIgMjAuNSAxMC40IDE5LjggMTAuMlpNNyAxNi41SDVWMTQuNUg3VjE2LjVaTTE5IDE2LjVIOVYxNC41SDE5VjE2LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Scanner = createIcon('Scanner', [
  [
    'path',
    {
      d: 'M19.8 10.2L4.2 4.5L3.5 6.4L17.6 11.5H5C3.9 11.5 3 12.4 3 13.5V17.5C3 18.6 3.9 19.5 5 19.5H19C20.1 19.5 21 18.6 21 17.5V12C21 11.2 20.5 10.4 19.8 10.2ZM7 16.5H5V14.5H7V16.5ZM19 16.5H9V14.5H19V16.5Z',
      key: 'f44azp',
    },
  ],
]);

export default Scanner;
